import { dt } from "@/shared/helper/datetime.ts";

export type FreshnessLevel = "fresh" | "stale" | "lost";

type Freshness = {
  level: FreshnessLevel;
  label: string;
};

/**
 * Насколько свежа последняя точка. Приложение курьера шлёт координату раз в
 * минуту, поэтому разрыв больше двух минут — уже повод присмотреться,
 * а больше пяти означает, что ключ в Redis вот-вот исчезнет.
 */
export function locationFreshness(updatedAt?: string | null): Freshness {
  if (!updatedAt) return { level: "lost", label: "нет данных" };

  const seconds = dt().diff(dt(updatedAt), "second");

  if (seconds < 0) return { level: "fresh", label: "только что" };

  if (seconds < 120) {
    return {
      level: "fresh",
      label: seconds < 60 ? "только что" : "минуту назад",
    };
  }

  const minutes = Math.floor(seconds / 60);

  if (seconds < 300) return { level: "stale", label: `${minutes} мин назад` };

  return { level: "lost", label: `${minutes} мин назад` };
}
